import { apolloClient } from '../apolloClient'
import { SIGN_IN } from './mutations/SIGN_IN'
import { setGlobal, setGlobalAndPersist } from '../../global/useGlobal'
import { SignIn, SignInVariables } from '../types/SignIn'
import { saveAuthResult } from './saveAuthResult'
import { SignInInput } from '../GlobalTypes'
import { platformConfig } from '../../constants/platform'

export const signIn = async (input: SignInInput, password: string) => {
  const response = await apolloClient.mutate<SignIn, SignInVariables>({
    mutation: SIGN_IN,
    variables: { input },
  })

  if (response) {
    await saveAuthResult(response)
    platformConfig.isWeb()
      ? await setGlobal({ userInfo: response.data?.signIn }) //TODO make a set global and persist using the local storage
      : await setGlobalAndPersist({
          userInfo: response.data?.signIn,
        })
  }

  return [response.data, password]
}
